import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
const DialogPef = ({ onClose, ...props }) => {
    const form = useFormik({
        initialValues: {
            observacoes: ''
        },
        validationSchema: yup.object({
            observacoes: yup.string().nullable()
        }),
        validateOnMount: false,
        onSubmit: async (values) => {
            onClose(values);
        }
    });
    return (<Dialog {...props}>
      <form>
        <DialogTitle>Pedido de emissão de fatura</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={12} md={12} xs={12}>
              <TextField label='Observações' name='observacoes' defaultValue={form.values?.observacoes} onChange={form.handleChange} onBlur={form.handleBlur} fullWidth error={form.touched.observacoes && Boolean(form.errors.observacoes)} helperText={form.touched.observacoes && form.errors.observacoes}/>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type='button' onClick={() => onClose(undefined)}>
            Cancelar
          </Button>
          <Button onClick={() => {
            form.handleSubmit();
        }} disabled={!form.isValid || !form.dirty || form.isSubmitting} variant='contained'>
            OK
          </Button>
        </DialogActions>
      </form>
    </Dialog>);
};
export default DialogPef;
